/* eslint-disable no-unused-vars */
import { Button, Grid, Typography } from "@mui/material";
import PDatePicker from "../../../../components/pos/PDatePicker";
import PFileUploader from "../../../../components/pos/PFileUploader";
import PSelect from "../../../../components/pos/PSelect";
import PText from "../../../../components/pos/PText";
import db from "../../../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StringUtils } from "../../../../utils/StringUtils";
import DocumentUploadListView from "./DocumentUploadListView";
import API from "../../../../utils/API";


export default function QuickPurchaseRequestOrderDetails(props) {
  const { t } = useTranslation();
  const translate = t;
  const [refereneNumber, setReferenenumber] = useState("AUTO");
  const [refereneNumberError, setReferenenumberError] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorError, setVendorError] = useState("");
  const [vendorOptions, setVendorOptions] = useState([]);
  const [paymentMode, setPaymentmode] = useState({
    name: "CREDIT",
    id: "CREDIT",
  });
  const [paymentModeError, setPaymentmodeError] = useState("");
  const [paymentTerms, setPaymentterms] = useState("");
  const [paymentTermsError, setPaymenttermsError] = useState("");
  const [paymentTermsOptions, setPaymenttermsOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceNumberError, setInvoiceNumberError] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [transactionDateError, setTransactionDateError] = useState("");
  const [note, setNote] = useState("");
  const [noteError, setNoteError] = useState("");
  const [attachmentName, setAttachmentName] = useState(null);
  const [showDocumentUploadWindow,setshowDocumentUploadWindow]=useState(false)

  const [liveValidation, setLiveValidation] = useState(false);

  const [filesList,setFilesList] =useState([]);
  const [uploadFileId,setUploadFileId] = useState([]);

  useEffect(() => {
    populateVendor();
    setPaymenttermsOptions([
      { name: "7 DAYS", id: 1 },
      { name: "10 DAYS", id: 6 },
      { name: "15 DAYS", id: 2 },
      { name: "30 DAYS", id: 3 },
      { name: "45 DAYS", id: 7 },
      { name: "60 DAYS", id: 8 },
      { name: "90 DAYS", id: 4 },
      { name: "100 DAYS", id: 5 },
    ]);
  }, []);

  useEffect(()=>{
    if(filesList){
      let arr = []
      for(let i=0;i<filesList.length;i++){
        arr.push(filesList[i].fileId)
      }
      setUploadFileId(arr)
    }
  },[filesList])

  useEffect(() => {
    if (paymentMode.id != "CREDIT") setPaymentterms("");
  }, [paymentMode]);

  useEffect(() => {
    if (props.purchaseOrderObj != null) populateData(props.purchaseOrderObj);
  }, [props.purchaseOrderObj]);

  const paymentModeOptions = [
    { name: "CREDIT", id: "CREDIT" },
    { name: "CASH", id: "CASH" },
  ];

  var biRef = {};

  props.biRef.requestCrud = {
    parentEvent: parentEvent,
  };

  function parentEvent(eventType, val1) {
    if (eventType == "getPayload") return createPayload(false);
    if (eventType == "getDraftPayload") return createPayload(false);
    if (eventType == "resetFileds") resetFields();
    if (eventType == "validation") {
      for (var i = 0; i < val1.messageList.length; i++) {
        var obj = val1.messageList[i];
        if (obj.field === "invoiceNo") {
          setInvoiceNumberError(obj.message);
        }
      }
    }
  }

  function populateData(inputData) {
    setReferenenumber(inputData.orderId);
    setVendor({
      id: inputData.vendorId,
      name: inputData.displayVendorName,
      bean: inputData.vendorBean,
    });
    props.setSelectedVendor(inputData.vendorBean);
    setPaymentmode({
      name: inputData.paymentMode,
      id: inputData.paymentModeId,
    });
    setPaymentterms({
      name: inputData.paymentTerms,
      id: inputData.paymentTermsId,
    });
    setInvoiceNumber(inputData.invoiceNumber);
    setTransactionDate(inputData.settlementDate);
    setNote(inputData.settlementNote);
    populateFile(inputData)
  }

  async function populateFile(inputData){   
    try{
      let fileData =[]
      let arr = inputData.fileId.split(',')
      let count=1
      for(let i=0;i<arr.length;i++){
        let { data } = await API.post("/api/v1/filelist", [arr[i]] );
        data.forEach((element)=>{
          let file = new Object();
          file["serialNumber"]=count;
          file["fileName"]=element.fileName;
          file["fileType"]=element.fileType;
          file["fileSizeText"]=element.fileSize;
          file["fileData"]=element.fileData;
          file["fileTypeText"]=element.fileTypeText;
          file["imageData"]=element.imageData;
          file["fileId"]=element.id
          fileData.push(file)
          count++;
        })
      }
      setFilesList(fileData);
    }catch(err){
      console.log(err)
    }
  }

  function resetFields() {
    setReferenenumber("AUTO");
    setReferenenumberError("");
    setVendor(null);
    setVendorError("");
    setPaymentmode({ name: "CREDIT", id: "CREDIT" });
    setPaymentmodeError("");
    setPaymentterms("");
    setPaymenttermsError("");
    setInvoiceNumber("");
    setInvoiceNumberError("");
    setTransactionDate("");
    setTransactionDateError("");
    setNote("");
    setNoteError("");
    setAttachmentName(null);
    setFilesList(null);
    setLiveValidation(false);
    setUploadFileId(null);
  }

  function validate() {
    let flag = true;
    if (!refereneNumber || refereneNumber === "") {
      setReferenenumberError(translate("Reference number is required"));
      flag = false;
    }
    if (!vendor || vendor === undefined) {
      setVendorError(translate("Vendor is required"));
      flag = false;
    }
    if (!paymentMode || paymentMode === "") {
      setPaymentmodeError(translate("Payment mode is required"));
      flag = false;
    } else if (paymentMode.id === "CREDIT") {
      if (!paymentTerms || paymentTerms === undefined) {
        setPaymenttermsError(translate("Payment terms is required"));
        flag = false;
      }
    }
    if (!invoiceNumber || invoiceNumber === "") {
      setInvoiceNumberError(translate("Invoice Number is required"));
      flag = false;
    }
    if (!transactionDate || transactionDate === "") {
      setTransactionDateError(translate("Transaction date is required"));
      flag = false;
    }
    return flag;
  }

  function createPayload(skipValidation) {
    if (skipValidation || validate()) {
      let saveObject = Object.create(null);
      saveObject["orderId"] = refereneNumber;
      saveObject["vendorId"] = vendor.id;
      saveObject["vendorBean"] = vendor.bean;
      saveObject["date"] = StringUtils.getIsoDate(transactionDate);

      saveObject["expectedDate"] = StringUtils.getIsoDate(transactionDate);
      saveObject["notes"] = note;
      //saveObject["status"] = "SETTLED";
      saveObject["paymentMode"] = paymentMode.name;
      saveObject["paymentTerms"] = paymentTerms.name;
      saveObject["paymentModeId"] = paymentMode.id;
      saveObject["paymentTermsId"] = paymentTerms.id;
      saveObject["isQuickEntry"] = true;
      saveObject["invoiceNumber"] = invoiceNumber;

      saveObject["settlementDate"] = StringUtils.getIsoDate(transactionDate);
      saveObject["settlementNote"] = note;     
      saveObject["fileId"]=uploadFileId.toString();
      return saveObject;
    } else return null;
  }

  useEffect(() => {
    if ((refereneNumber != null && refereneNumber) != "")
      setReferenenumberError("");
  }, [refereneNumber]);
  useEffect(() => {
    if (vendor != null && vendor != "") setVendorError("");
  }, [vendor]);
  useEffect(() => {
    if (paymentMode != null && paymentMode != "") setPaymentmodeError("");
  }, [paymentMode]);
  useEffect(() => {
    if (paymentTerms != null && paymentTerms != "") setPaymenttermsError("");
  }, [paymentTerms]);
  useEffect(() => {
    if (transactionDate != null && transactionDate != "")
      setTransactionDateError("");
  }, [transactionDate]);
  useEffect(() => {
    if (invoiceNumber != null && invoiceNumber != "") setInvoiceNumberError("");
  }, [invoiceNumber]);


  function handleAddFileClick() {
    setshowDocumentUploadWindow(true)
  }


  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name, bean: data[i] });
        }
      }
      setVendorOptions(dat);
    });
  }

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Reference No")}
                  </Typography>
                </td>
                <td>
                  <PText
                    readOnly={true}
                    value={refereneNumber}
                    error={refereneNumberError}
                    InputProps={{ readOnly: true }}
                    onChange={(e) => setReferenenumber(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Invoice No")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={invoiceNumber}
                    error={invoiceNumberError}
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                  ></PText>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={4}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Vendor")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={vendorOptions}
                    value={vendor}
                    errorMessage={vendorError}
                    onChange={(event, newValue) => {
                      setVendor(newValue);
                      if (newValue.bean && newValue.bean.paymentMode) {
                        setPaymentmode({
                          name: newValue.bean.paymentMode,
                          id: newValue.bean.paymentMode,
                        });
                      }
                      if (newValue.bean && newValue.bean.paymentTerms) {
                        setPaymentterms({
                          name: newValue.bean.paymentTerms,
                          id: newValue.bean.paymentTerms,
                        });
                      }
                      props.setSelectedVendor(newValue.bean);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Note")}</Typography>
                </td>
                <td>
                  <PText
                    value={note}
                    error={noteError}
                    onChange={(e) => setNote(e.target.value)}
                  ></PText>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={3}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Mode")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentModeOptions}
                    value={paymentMode}
                    errorMessage={paymentModeError}
                    onChange={(event, newValue) => {
                      setPaymentmode(newValue);
                      setPaymenttermsError("");
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Date")}</Typography>
                </td>
                <td>
                  <PDatePicker
                    defaultValue="2020-08-23"
                    value={transactionDate}
                    error={transactionDateError}
                    onChange={(value) => {
                      setTransactionDate(value);
                    }}
                  ></PDatePicker>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={2}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Terms")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentTermsOptions}
                    value={paymentTerms}
                    disabled={
                      paymentMode == null || paymentMode.id == "CREDIT"
                        ? false
                        : true
                    }
                    errorMessage={paymentTermsError}
                    onChange={(event, newValue) => {
                      setPaymentterms(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("File")}</Typography>
                </td>
                <td>
                  <Button onClick={handleAddFileClick} color="primary">
                      { translate("Document")}
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
      {showDocumentUploadWindow &&(<DocumentUploadListView
      showDocumentUploadWindow={showDocumentUploadWindow}
      setshowDocumentUploadWindow={setshowDocumentUploadWindow}
      filesList={filesList}
      setFilesList={setFilesList}
      showMessage={props.showMessage}
      setUploadFileId={setUploadFileId}
      ></DocumentUploadListView>)}
    </div>
  );
}
